import { Logger } from '@nicejob/nicejob-logger';

/** Globals */
const SOURCE = 'library/schema';

/** Lazy init */
let LOG: Logger | null = null;

/**
 * Initializes or fetches Logger module from memory
 */
export function getLogger(): Logger {
    if (!LOG) {
        LOG = new Logger({
            default_metadata: { source: SOURCE },
        });
    }

    return LOG;
}

export const stringify: (obj: any) => string = require('json-stable-stringify-without-jsonify');
